import { createColumnHelper } from "@tanstack/react-table";

import { Patient } from "~/common/utils";
import { NotificationPoint } from "~/providers/components";
import {
  formatConsultationRequestRowData,
  formatDateToComplete,
  getFullName,
} from "~/providers/utils";
import { ConsultationRequestsTableActionsCell } from "./ConsultationRequestsTableActionsCell";
import { CONSULTATION_REQUESTS_TABLE_COLUMN_IDS } from "./consultationRequestsTableSorting";

const columnHelper = createColumnHelper<Patient>();

export const consultationRequestsTableColumns = [
  columnHelper.accessor((row) => getFullName(row.name, row.last_name), {
    id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.name,
    header: "Name",
    cell: ({ row }) => {
      const { name, last_name: lastName, organization_patients } = row.original;
      const unreviewed = !organization_patients?.[0].is_reviewed;

      return (
        <div className="flex items-center gap-4 capitalize">
          <NotificationPoint
            className={unreviewed ? "text-red-500" : "text-neutral-200"}
          />
          {getFullName(name, lastName)}
        </div>
      );
    },
  }),
  columnHelper.accessor(
    (row) => formatConsultationRequestRowData(row).description ?? "-",
    {
      id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.consultationStatus,
      header: "Consultation status",
      cell: ({ row }) => (
        <span className="inline-block first-letter:uppercase">
          {formatConsultationRequestRowData(row.original).description ?? "-"}
        </span>
      ),
    },
  ),
  columnHelper.accessor(
    (row) =>
      getFullName(
        row.organization_patients?.[0]?.primary_provider?.name,
        row.organization_patients?.[0]?.primary_provider?.last_name,
      ) || "-",
    {
      id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.primaryProvider,
      header: "Primary provider",
      cell: ({ row }) => {
        const providerName = getFullName(
          row.original.organization_patients?.[0]?.primary_provider?.name,
          row.original.organization_patients?.[0]?.primary_provider?.last_name,
        );

        return providerName || "-";
      },
    },
  ),
  columnHelper.accessor(
    (row) => row.organization_patients?.[0]?.invitation_link.label ?? "-",
    {
      id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.source,
      header: "Source",
      cell: ({ row }) => (
        <span className="first-letter:uppercase">
          {row.original.organization_patients?.[0]?.invitation_link.label ??
            "-"}
        </span>
      ),
    },
  ),
  columnHelper.accessor((row) => formatConsultationRequestRowData(row).state, {
    id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.state,
    header: "State",
    cell: ({ row }) => formatConsultationRequestRowData(row.original).state,
  }),
  columnHelper.accessor(
    (row) =>
      row.last_feed ? formatDateToComplete(row.last_feed.created_at) : "-",
    {
      id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.lastUpdated,
      header: "Last updated",
      cell: ({ row }) => {
        const date = row.original.last_feed?.created_at;

        return <span>{date ? formatDateToComplete(date) : "-"}</span>;
      },
    },
  ),
  columnHelper.display({
    id: CONSULTATION_REQUESTS_TABLE_COLUMN_IDS.actions,
    header: "",
    enableSorting: false,
    cell: ({ row }) => (
      <div className="flex justify-end px-5">
        <ConsultationRequestsTableActionsCell patient={row.original} />
      </div>
    ),
  }),
];
